import React from 'react'
import { Box, Typography } from '@mui/material'
import InstagramIcon from '@mui/icons-material/Instagram';
import LinkedInIcon from '@mui/icons-material/LinkedIn';
import FacebookIcon from '@mui/icons-material/Facebook';
import TwitterIcon from '@mui/icons-material/Twitter';
import GitHubIcon from '@mui/icons-material/GitHub';
import SubscriptionsRoundedIcon from '@mui/icons-material/SubscriptionsRounded';
const Footer = () => {
  return (
   <>
   <Box sx={{textAlign:'center', bgcolor:'#1A1A19', color:"white", padding:'20px'}}>
    <Box sx={{my:2, "& svg":{
        fontSize:"60px",
        cursor: 'pointer',
        mr: 2,
    },
    "& svg:hover":{
        color:'goldenrod',
        transform:'translateX(5px)',
        transition: "all 400ms",


    }
    }}>
        {/*social media icons*/}
        <InstagramIcon/>
        <LinkedInIcon/>
        <FacebookIcon/>
        <TwitterIcon/>
        <GitHubIcon/>
        <SubscriptionsRoundedIcon/>
    </Box>
    <Typography variant='h5'>All Rights Reserved &copy;</Typography>
   </Box>
   </>
  )
}

export default Footer
